// extracted by mini-css-extract-plugin
export default {"richTextEditor":"RichTextEditor_richTextEditor__Rwlwh","richTextEditorToolbar":"RichTextEditor_richTextEditorToolbar__-op3u","inputLabel":"RichTextEditor_inputLabel__XSb2J"};